export enum EAdvancedFilterTimelineDate {
  START_DATE = 'START_DATE',
  END_DATE = 'END_DATE',
  IS_EMPTY = 'IS_EMPTY',
  IS_NOT_EMPTY = 'IS_NOT_EMPTY',
  IS_BETWEEN = 'IS_BETWEEN',
}
